import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'
import focus from '@mailobj-browser/front/js/events/types/focus.js'
import closest from '@mailobj-browser/front/js/selectors/closest.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import { modifiers } from '../styles.js'
import { rtes } from './iframe.js'

const onFocus = object(listener, {
  type: focus,
  passive,
  task: (element) => {
    const form = closest('form', element)
    const { contentDocument } = one('iframe', form)
    const rte = rtes.get(contentDocument)

    if (rte) {
      rte.classList.remove(modifiers.rte_iframe.focused)
    }
  }
})

export default element => {
  onFocus.listen(element)
}